import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { openModal } from 'reducers/modalReducer';
import { getBlockingInstructions } from 'services/businessRelationService';
import { BlockingInstruction } from 'types/BlockingInstructionTypes';
import { isNotNullOrUndefined } from 'utils/utils';

export const useFetchBlockingInstructions = (techId?: string, enabled = true) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const query = useQuery<BlockingInstruction[], AxiosError>({
    queryKey: ['fetchBlockingInstructions', techId],
    queryFn: () => getBlockingInstructions(techId),
    enabled: isNotNullOrUndefined(techId) && enabled,
    retry: 3,
    retryDelay: 2_000,
  });

  useEffect(() => {
    if (isNotNullOrUndefined(query.error)) {
      dispatch(
        openModal({
          modalType: 'JBErrorModalWrapper',
          modalProps: {
            technicalInfo: {
              details: t('accounts.tabs.blockingInstructions.error.details'),
              title: t('accounts.tabs.blockingInstructions.error.title'),
              userErrorMessage: t('accounts.tabs.blockingInstructions.error.userMessage'),
            },
            httpError: query.error,
          },
        }),
      );
    }
  }, [query.error, dispatch, t]);

  return query;
};
